import React,{ Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import Confirm from '../Layout/Confirm';
import { sanitizeData } from '../../../Utilities/Common';

class TypeRow extends Component{

    render(){
        let { token, type: { id, name } } = sanitizeData(this.props);
        return (
            <tr key={id+520}>
                <td><span style={{cursor: "pointer"}} onClick={() => this.props.edit(id)} className="btn-link">{name}</span></td><td><Confirm confirm={() => this.props.deleteType(token,id)} /></td>
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.types)(TypeRow);


// WEBPACK FOOTER //
// ./src/Components/App/Types/TypeRow.js